import { Controller } from "../../Controller";
import { ListarBancosService } from "../../../Services/Geral/ListarBancosServices/ListarBancosServices";

export async function ListarBancosController() {
    return Controller(ListarBancosService());
}
